const geracao_de_arquivo_de_vagas = [
  {
    path: "/geracao-de-arquivo-de-vagas",
    redirect: "/geracao-de-arquivo-de-vagas",
    meta: {
      breadCrumb: "Formação de Turmas - Gerar Arquivo de Turmas",
    },
    children: [
      {
        path: "/geracao-de-arquivo-de-vagas",
        name: "geracao_de_arquivo_de_vagas",
        meta: {
          allowedPermissions: ["exportar_estrutura_turma"],
        },
        component: () =>
          import(
            "@/views/GeracaoDeArquivoDeVagas/GeracaoDeArquivoDeVagasHome.vue"
          ),
      },
    ],
  },
];

export { geracao_de_arquivo_de_vagas };
